import {
  Flex,
  Highlight,
  Stack,
  Text,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import {
  TagCapsules,
  SectionsForm,
  AcceptProductTerms,
  FinishStep,
} from "../../components";
import ProductPlans from "./ProductPlans";
import { IColor } from "../../utils/selectColors";
import { InfoCircle } from "iconsax-react";
import { useFormContext } from "react-hook-form";
import { client_selected } from "../../client";
import { IPostBuyNow } from "../../interfaces/PurchaseNow";
import { IProductComplete } from "../../interfaces/Products/IProductDetail";
import { useTranslation } from "react-i18next";
import { useTermsByLanguage } from "../../utils/GetTerms";
import {
  tradutorCategory,
  tradutorSubcategory,
} from "../../utils/SubCategorys";
interface IProps {
  product: IProductComplete | undefined;
}

const PurchaseStep2 = ({ product }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const name = client_selected.name;
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<IPostBuyNow>();

  const hasDirtyFirst =
    !!watch("user.name") &&
    !!watch("user.document_nr") &&
    !!watch("user.email") &&
    !!watch("user.cell_phone") &&
    !!watch("user.term_of_contract");

  const acceptTerm = watch("term_of_product");

  const handleAcceptTerm = () => {
    setValue("term_of_product", !acceptTerm);
  };

  const termsLink = useTermsByLanguage();

  return (
    <SectionsForm
      title={t("marketplace.comprar_agora.purchase_step_2.title_section")}
      number={"02"}
    >
      {!!errors?.plan_id?.message ? (
        <Flex
          gap="10px"
          bg="alertsOpacity.0"
          p="10.5px 0"
          w="100%"
          align="center"
          justify="center"
          sx={{ borderRadius: "8px" }}
        >
          <Tooltip
            multiline
            w={236}
            label={errors?.plan_id?.message}
            withArrow
            transitionProps={{ duration: 200 }}
          >
            <InfoCircle size={24} color={theme.colors.alerts[0]} />
          </Tooltip>
          <Highlight
            highlight={["24 Horas"]}
            size={12}
            lh="19px"
            color="alerts.0"
            fw={500}
            sx={{
              "& [data-highlight]": {
                backgroundColor: "unset",
                fontWeight: 700,
              },
            }}
          >
            {errors?.plan_id?.message}
          </Highlight>
        </Flex>
      ) : null}
      {hasDirtyFirst && !!product ? (
        <Flex gap="32px" w="100%" justify="space-between" direction={"column"}>
          <Flex direction="column" gap="0" w="100%">
            <Flex direction="column" gap="32px" w="100%" p="16px 16px 0">
              <Flex justify={"space-between"} gap="md">
                <Flex align="center" gap="md">
                  <Flex gap="16px" align="center">
                    <Flex
                      w="60px"
                      h="60px"
                      sx={{
                        backgroundImage: `url(${product.product.icon})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "12px",
                      }}
                    />

                    <Stack spacing={4}>
                      <Flex gap="8px">
                        <TagCapsules colorTag={IColor.orange} border>
                          {t(tradutorCategory(product.product.category).title)}
                        </TagCapsules>
                        <TagCapsules colorTag={IColor.yellow} border>
                          {t(
                            tradutorSubcategory(product.product.subcategory)
                              .title
                          )}
                        </TagCapsules>
                      </Flex>
                      <Text weight={700} size="xl" color="dark">
                        {product.product.title}
                      </Text>
                    </Stack>
                  </Flex>

                  <Stack spacing={0}>
                    <Text color="gray" size="sm">
                      {t("marketplace.comprar_agora.purchase_step_2.sell_by")}
                    </Text>
                    <Text color="dark" weight={600} size="sm">
                      {product.product?.partner?.name ?? name}
                    </Text>
                  </Stack>
                </Flex>
              </Flex>
              <ProductPlans product={product} />
              <AcceptProductTerms
                acceptTerm={acceptTerm}
                handleAcceptTerm={handleAcceptTerm}
                link={product?.product?.term_of_contract || termsLink}
              />
            </Flex>
          </Flex>
        </Flex>
      ) : (
        <FinishStep />
      )}
    </SectionsForm>
  );
};
export default PurchaseStep2;
